/**
 * @fileoverview POST handler for the "/apps/business/users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessUsersCacheKeys } from "./constants";
import type { PostAppsBusinessUsersProps } from "./types";

export const postAppsBusinessUsers = reactQueryMutationAdapter(
  appsBusinessUsersCacheKeys,
  (props: PostAppsBusinessUsersProps): Promise<object> => {
    return fetch("/apps/business/users", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
